import { useDropzone } from "react-dropzone";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

DropZone.propTypes = {
  onDrop: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired, // Ensures AG-Grid stays inside
};

export default function DropZone({ onDrop, children }) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    noClick: true,
  });

  return (
    <Box
      {...getRootProps()}
      sx={{
        position: "relative",
        border: isDragActive ? "2px dashed #1976d2" : "solid thin rgb(43 45 47 / 24%)",
        transition: "border 0.2s ease-in-out",
        backgroundColor: isDragActive ? "rgba(25, 118, 210, 0.1)" : "transparent",
      }}
    >
      <input {...getInputProps()} />
      {isDragActive && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(25, 118, 210, 0.2)",
            zIndex: 2,
            pointerEvents: "none",
          }}
        >
          <Typography variant="h6" color="primary">
            Drop files here
          </Typography>
        </Box>
      )}
      {children}
    </Box>
  );
}
